import JobEditor from './editor/editor.vue'
import BlankLayout from '../layout/blankLayout.vue'
import { TAB_CATEGORY } from '@/constant/permission'
import i18n from '@/i18n'

const routes = [
  {
    name: 'addJob',
    path: '/v-admin/job/add',
    component: JobEditor,
    meta: {
      isEditMode: false,
      permission: { strict: false, any: ['PERM_JOB_CREATE', 'PERM_JOB_CREATE_FROM_TEMPLATE'] },
      titleI18nKey: 'admin.job.editor.title.addJob',
      rootLayout: {
        hiddenLeftPadding: true
      }
    }
  },
  {
    name: 'editJob',
    path: '/v-admin/job/edit/:jobId',
    component: JobEditor,
    meta: {
      isEditMode: true,
      titleI18nKey: 'admin.job.editor.title.editJob',
      rootLayout: {
        hiddenLeftPadding: true
      }
    }
  }
]

const jobRoute = {
  name: 'jobLayout',
  path: '/v-admin/job/',
  component: BlankLayout,
  redirect: '/v-admin/job/add',
  meta: {
    permission: TAB_CATEGORY.JOB,
    get title () {
      return i18n.t('admin.jobList.title')
    },
    tab: {
      get label () {
        return i18n.t('admin.jobList.tab')
      },
      customClass: ['job']
    }
  },
  children: routes
}
export default jobRoute
